import { useAuthenticator } from "@aws-amplify/ui-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface LogoutConfirmDialogProps {
  isOn: boolean;
  setIsOn: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({
  isOn,
  setIsOn,
}) => {
  const { signOut } = useAuthenticator();
  const navigate = useNavigate();

  const handleLogout = () => {
    signOut();
    navigate("/");
    setIsOn(false);
  };

  return (
    <Dialog open={isOn}>
      <DialogTitle>確認</DialogTitle>
      <DialogContent>
        <DialogContentText>ログアウトします。宜しいですか？</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsOn(false)}>キャンセル</Button>
        <Button onClick={handleLogout}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};
